module.exports = __webpack_public_path__ + "img/CM-SL-CA-Volkswagen-Established.d0d41557.jpg";